import { Brokerage } from '../brokerages';

export const defaultCompany: Brokerage = {
  id: '',
  searchesProfile: '',
  bdmAssigned: '',
  nextAnnualReviewDate: '',
  companyDetails: {
    id: '',
    status: 'Active',
    fcaNumber: '',
    tradingCompanyName: '',
    registeredCompanyName: '',
    telephoneNumber: '',
    emailAddress: '',
    webAddress: '',
    hasRegulatoryPermission: false,
    address: {
      subBuilding: '',
      houseName: '',
      houseNumber: '',
      street: '',
      postTown: '',
      postCode: '',
    },
    authorisationType: 'DIRECTLY_AUTHORISED',
    icoNumber: '',
    companyRegistrationNumber: '',
    professionalIndemnity: '',
    levelOfCover: '',
  },
  principalCompany: {
    id: '',
    fcaNumber: '',
    tradingCompanyName: '',
    registeredCompanyName: '',
    telephoneNumber: '',
    emailAddress: '',
    webAddress: '',
    hasRegulatoryPermission: false,
    address: {
      subBuilding: '',
      houseName: '',
      houseNumber: '',
      street: '',
      postTown: '',
      postCode: '',
    },
    icoNumber: '',
    companyRegistrationNumber: '',
  },
  notifications: {
    emailCaseOwner: false,
    additionalEmailAddresses: [],
  },
  representatives: [],
  bankAccounts: [],
  commercialDetails: {
    id: '',
    commissionPaymentAccount: '',
    feePaymentAccount: '',
    commissionDetails: [],
    isPackager: false,
    maxBrokerFee: 0,
  },
  isPackager: false,
};
